import { MRT_ColumnDef } from "material-react-table";
import { Box, Button, Chip, Divider, IconButton, Tooltip, Typography } from "@mui/material";
import CustomPopup from "../../../shared/components/modals/custom-popup";
import { click } from "@testing-library/user-event/dist/click";
import CBReasonDetails from "./cb-reason-deatils";
import { MouseEvent, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../../shared/components/buttons/buttons";
import ModalPopup from "../../../shared/components/modals/custom-popup";
import DataDisplay from "../tc-components/tc-error-detail-panel";
import moment from "moment";
import { StyledButton } from "../../../shared/components/buttons/custom-button";
import { ActionsMenu } from "../../../shared/components/table/custom-actions";
import { useApi } from "../../../shared/hooks/useApi";
import { TCAppConfig } from "../../../shared/app-configs/tc-app-configs";
import { useTransactionCertificateStore } from "../../../store/transaction-certificates.store";
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RateReviewIcon from '@mui/icons-material/RateReview';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { notify } from "../../../shared/utils/notify.utills";
import FileView from "../tc-components/ml-files-detail-panel";
import { MLAppConfig } from "../../../shared/app-configs/ml-app-configs";
import ViewerModalPopup from "../../../shared/components/modals/viewerModal";
import PdfViewer from "../../../shared/components/preview/pdf-viewer";
import ATCAppConfig from "../../../shared/app-configs/atc-app-configs";

// Common status cell renderer
export const StatusCell = ({ cell }: { cell: any }) => {
    const status = cell.getValue() as string;
    let color: "default" | "primary" | "secondary" | "error" | "info" | "success" | "warning" = "default";
    switch (status) {
        case "Submitted": color = "success"; break;
        case "Success": color = "success"; break;
        case "Amending": color = "info"; break;
        case "Rejected": color = "error"; break;
        case "Created": color = "warning"; break;
        case "Draft": color = "warning"; break;
        default: color = "default";
    }
    return <Chip label={status} color={color} size="small" variant="outlined" />;
};

export const certifiedWeightCell = ({ cell }: { cell: any }) => {
    const weightUsed = cell.getValue() as string;
    if (parseInt(weightUsed) > 0) {
        return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(parseInt(weightUsed));
    }
    return weightUsed
};


interface NavTCNoProps {
    cell: {
        getValue: () => string;
        row: {
            original: {
                tcMetadataStatus: string;
                tcId: string;
                tcParentMetadataStatus: string;
                tcNo?: string;
                tcVersionNumber?: string;
                [key: string]: any;
            };
        };
    },
    type: string;
}
const NavTCNo: React.FC<NavTCNoProps> = ({ cell, type }) => {
    const navigate = useNavigate();
    const { setEditTCInfo,cbLicensingCode } = useTransactionCertificateStore();
    // Extracting necessary values
    const tcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, tcId, tcParentMetadataStatus } = cell.row.original;
    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        if (type === 'suppliers') {
            navigate(`/tc/submited-tc/transaction-certificate/${tcId}`);
        }
        else {
            if (
              tcParentMetadataStatus === "Submitted" || 
              tcParentMetadataStatus === "Success" || 
              tcParentMetadataStatus === "Rejected" ||
              tcMetadataStatus === "Amending"
            ) {
                setEditTCInfo({ tcId: tcId, isParentStatus: true });
            }
            else {
                setEditTCInfo({ tcId: tcId, isParentStatus: false });
            }
            navigate(`/tc/tc-details/transaction-certificate/${tcId}`);
        }
        // if (tcMetadataStatus === "Submitted" || tcMetadataStatus === "Success") {
        //     navigate(`/tc/submited-tc/transaction-certificate/${tcId}`);
        // }
        // else if (tcMetadataStatus === "Rejected") {
        //     navigate(`/tc/rejected-tc/transaction-certificate/${tcId}`);
        // }
        // else {
        //     navigate(`/tc/tc-details/transaction-certificate/${tcId}`);
        // }
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {tcNo}
        </Typography>
    );
};


// const EditNavTCNo: React.FC<NavTCNoProps> = ({ cell, type }) => {
//     const navigate = useNavigate();
//     const row = cell.row.original;
//     // Extracting necessary values
//     const tcNo = cell.getValue(); // Transaction Certificate Number
//     const { tcId, tcMetadataStatus } = cell.row.original;

//     // Click handler to navigate based on tcMetadataStatus
//     const handleNavigation = () => {
//         console.log(`row value edit ${JSON.stringify(row)}`);

//         // if (type === 'suppliers') {
//         //     navigate(`/tc/submited-tc/transaction-certificate/${tcId}`);
//         // }
//         // else
//         //     navigate(`/tc/tc-details/transaction-certificate/${tcId}`);
//     };

//     return (
//         <>
//             {
//                 row.tcMetadataStatus === 'Submitted' || row.tcMetadataStatus === 'Success' || row.tcMetadataStatus === 'Rejected' ?
//                     <CustomButton variant="text" sx={{ textTransform: "none" }} size="small" label="Edit" onClick={handleNavigation}>
//                     </CustomButton> : null
//             }
//         </>
//     );
// };
interface NavETCNoProps {
    cell: {
        getValue: () => string;
        row: {
            original: {
                tcMetadataStatus: string;
                etcId: string;
            };
        };
    };
}

export const NavETCNo: React.FC<NavETCNoProps> = ({ cell }) => {
    const navigate = useNavigate();

    // Extracting necessary values
    const etcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, etcId } = cell.row.original;

    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        navigate(`/etc/view-etc/transaction-details/${etcId}`);
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {etcNo}
        </Typography>
    );
};
export const NavSupNo: React.FC<any> = ({ cell }) => {
    const navigate = useNavigate();

    // Extracting necessary values
    const tcNo = cell.getValue(); // Transaction Certificate Number
    const { tcMetadataStatus, tcId } = cell.row.original;

    // Click handler to navigate based on tcMetadataStatus
    const handleNavigation = () => {
        navigate(`/tc/submited-tc/transaction-certificate/${tcId}`);
    };

    return (
        <Typography
            onClick={handleNavigation}
            variant="body2"
            sx={{
                cursor: "pointer",
                color: "primary.main",
                textDecoration: "underline",
                "&:hover": {
                    color: "primary.dark", // Slightly darker color on hover
                },
                "&:active": {
                    textDecoration: "none", // Remove underline when clicked
                },
            }}
        >
            {tcNo}
        </Typography>
    );
};
const RejectReasonCell = ({ row }: { row: any }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const rejectionReasons = Array.isArray(row.original.tcMetadataRejectionReason)
        ? row.original.tcMetadataRejectionReason
        : [row.original.tcMetadataRejectionReason];

    return (
        <>
            {Array.isArray(row.original.tcMetadataRejectionReason) ? (
                <>
                    <CustomButton variant="text" sx={{ textTransform: "none" }} size="small" label="Show Reason" onClick={handleOpen}>
                    </CustomButton>
                    <ModalPopup open={open} onClose={handleClose} title="Rejection Reason">
                        <DataDisplay data={rejectionReasons} />
                    </ModalPopup>
                </>
            ) : (
                <span>{row.original.tcMetadataRejectionReason}</span>
            )}
        </>
    );
};

export const InventoryFIlesView = ({ row }: { row: any }) => {
    const [open, setOpen] = useState(false);
    const [sasUrls, setSasUrls] = useState<{[key: string]: string}>({});
    const [isLoading, setIsLoading] = useState(false);

    const handleOpen = () => {
        setOpen(true);
        fetchSasUrls();
    };
    
    const handleClose = () => setOpen(false);
    
    const { executeGet } = useApi();
    const files = Array.isArray(row.original.files)
        ? row.original.files
        : [row.original.files];

    const hasFiles = row.original.files && 
                    (Array.isArray(row.original.files) 
                      ? row.original.files.length > 0
                      : (row.original.files.fileName && row.original.files.fileName.length > 0));

    const getSasUrl = async (filePath: string) => {
        try {
            const formattedPath = `['${filePath}']`;
            console.log("formattedPath", formattedPath);
            const result: any = await executeGet(MLAppConfig.GET_SAS_URL, {
                files: formattedPath
            });
            console.log("sasURL------->", JSON.stringify(result.data));
            return result.data[0];
        } catch (error: any) {
            throw new Error(`Failed to get SAS URL: ${error.message}`);
        }
    };
    
    const fetchSasUrls = async () => {
        if (!row.original.files || !row.original.files.filePath) return;
        
        setIsLoading(true);
        try {
            const urls: {[key: string]: string} = {};
            const filePaths = row.original.files.filePath;
            const fileNames = row.original.files.fileName;
            
            if (Array.isArray(filePaths)) {
                for (let i = 0; i < filePaths.length; i++) {
                    const url = await getSasUrl(filePaths[i]);
                    urls[fileNames[i]] = url;
                }
            }
            // console.log("urls-------->", urls);
            setSasUrls(urls);
        } catch (error) {
            console.error("Error fetching SAS URLs:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {hasFiles ? (
                <>
                    <CustomButton 
                        variant="text" 
                        sx={{ textTransform: "none" }} 
                        size="small" 
                        label="Show Files" 
                        onClick={handleOpen}
                    >
                    </CustomButton>
                    <ModalPopup open={open} onClose={handleClose} title="Inventory Files">
                        <FileView files={files} sasUrls={sasUrls} isLoading={isLoading} />
                    </ModalPopup>
                </>
            ) : (
               <span> </span>
            )}
        </>
    );
};
const EditTC: React.FC<NavTCNoProps> = ({ cell, type }) => {
    const { tcId, tcMetadataStatus, tcParentMetadataStatus } = cell.row.original;
    const navigate = useNavigate();
    const { setEditTCInfo,cbLicensingCode} = useTransactionCertificateStore();
    const { executePost } = useApi();
    const [previewOpen, setPreviewOpen] = useState(false);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const togglePreviewDrawer = () => setPreviewOpen((prev) => !prev);
    const isCbUser = cbLicensingCode.startsWith("CB");

  // Click handler to navigate based on tcMetadataStatus
  const handleNavigation = (row: any) => {
    if (type === 'suppliers') {
        navigate(`/tc/submited-tc/transaction-certificate/${tcId}`);
    }
    else {
        if (
            row?.tcMetadataStatus === "Submitted" || 
            row?.tcMetadataStatus === "Success" || 
            row?.tcMetadataStatus === "Rejected" ||
            row?.tcMetadataStatus === "Amending"
          ) {
            setEditTCInfo({ tcId: tcId, isParentStatus: true });
          }
          else {
          setEditTCInfo({ tcId: tcId, isParentStatus: false });
        }
        navigate(`/tc/tc-details/transaction-certificate/${tcId}`);
    }
  };

  const handleEdit = async (row: any) => {
    try {
      const {
        tcVersionNumber,
        ...restData
      } = row;
      const payload = {
        ...restData,
        tcVersionNo: tcVersionNumber,
        tcCbLicensingCode: cbLicensingCode
      };

      const url = `${TCAppConfig.EDIT_TC_DETAILS}?` +
      `tcId=${tcId}&` +
      `tcCbLicensingCode=${encodeURIComponent(cbLicensingCode)}`;

      const result: any = await executePost(
        url,
        payload
      );

      if (result.status === 200) {
        if (
          tcMetadataStatus === "Submitted" ||
          tcMetadataStatus === "Success" ||
          tcMetadataStatus === "Rejected"
        ) {
          setEditTCInfo({
            tcId: result.data.tcId,
            isParentStatus: true,
            tcMetadataStatus: tcMetadataStatus,
          });
        } else {
          setEditTCInfo({});
        }
        navigate(`/tc/tc-details/transaction-certificate/${result.data.tcId}`);
        
      } else {
        // throw new Error(`Failed to edit TC: ${result.statusText}`);
      }
    } catch (error) {
      console.error('Error editing TC:', error);
      throw error;
    }
  };

    const handleView = async (row: any) => {
        try {
            setPreviewOpen(true);
        }
        catch (e) {
            console.error(`Exception Occured in Viewing TC ${e}`)
        }
    }

    const handleUploadPdf = () => {
        fileInputRef.current?.click();
    };

const handleFileChange = async (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  const file = event.target.files?.[0];
  if (!file) return;

  if (file.type !== 'application/pdf') {
    notify('Only PDF files are allowed', 'error');
    return;
  }

  // Validate file name format: TC_CBCode_tcNo_YYYYMMDD.pdf
  const fileName = file.name;
  const fileNamePattern = /^TC_([A-Z0-9]{3})_(.+)_(\d{8})\.pdf$/i;
  const match = fileName.match(fileNamePattern);

  if (!match) {
    notify('Invalid file name format. Expected format: TC_CBCode_tcNo_YYYYMMDD.pdf', 'error');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    return;
  }

  const [, cbCode, tcNo, dateStr] = match;

  if (cbCode.length !== 3) {
    notify('CB code must be exactly 3 characters long', 'error');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    return;
  }

  const year = parseInt(dateStr.substring(0, 4));
  const month = parseInt(dateStr.substring(4, 6));
  const day = parseInt(dateStr.substring(6, 8));

  if (year < 1900 || year > 2100 || month < 1 || month > 12 || day < 1 || day > 31) {
    notify('Invalid date in file name. Date must be in YYYYMMDD format', 'error');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    return;
  }

  const dateObj = new Date(year, month - 1, day);
  if (dateObj.getFullYear() !== year || dateObj.getMonth() !== month - 1 || dateObj.getDate() !== day) {
    notify('Invalid date in file name. Please provide a valid date', 'error');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    return;
  }

  try {
    const formData = new FormData();

    formData.append('tc_id', cell.row.original.tcId);
    formData.append('tc_no', cell.row.original.tcNo ?? '');
    formData.append('status', cell.row.original.tcMetadataStatus);
    formData.append(
      'tc_version_no',
      cell.row.original.tcVersionNumber ?? ''
    );
    formData.append('file', file);
    formData.append('cb_id', 'CB-CUC'); 

    const result = await executePost(
      TCAppConfig.TC_UPLOAD_PDF,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (result?.status === 200) {
     notify(`PDF uploaded successfully`, 'success');
    }
  } catch (error) {
    console.error('Error uploading PDF:', error);
    notify('Error uploading PDF', 'error');
  } finally {
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  }
};


    return (
        <>
            <Box display="flex" alignItems="center">
                {["Success"].includes(tcMetadataStatus) && (
                    <>
                        <Tooltip title="Upload PDF">
                            <IconButton onClick={handleUploadPdf} color="primary">
                                <UploadFileIcon sx={{ fontSize: 20, color: '#2C4748' }} />
                            </IconButton>
                        </Tooltip>
                        <Divider flexItem sx={{ marginX: 1 }} />
                    </>
                )}
                {["Success", "Rejected"].includes(tcMetadataStatus) && (
                    <>
                        <Tooltip title="Edit">
                            <IconButton onClick={() => handleEdit(cell.row.original)} color="primary">
                                <EditIcon sx={{ fontSize: 20, color: '#353C52' }} />
                            </IconButton>
                        </Tooltip>
                        <Divider flexItem sx={{ marginX: 1 }} />
                    </>
                )}
                {["Amending", "Draft"].includes(tcMetadataStatus) && isCbUser && (
                    <>
                        <Tooltip title="Continue Submission">
                            <IconButton onClick={() => handleNavigation(cell.row.original)} color="primary">
                                <RateReviewIcon sx={{ fontSize: 20, color: '#2C4748' }} />
                            </IconButton>
                        </Tooltip>
                        <Divider flexItem sx={{ marginX: 1 }} />
                    </>
                )}
                {tcMetadataStatus !== "Draft" && (
                    <Tooltip title="View">
                        <IconButton onClick={() => handleView(cell.row.original)} color="primary">
                            <VisibilityIcon sx={{ fontSize: 20, color: '#F0CD7F' }} />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            <input
                type="file"
                ref={fileInputRef}
                style={{ display: 'none' }}
                accept=".pdf"
                onChange={handleFileChange}
            />
            {tcId && (
                <ViewerModalPopup
                    open={previewOpen}
                    onClose={togglePreviewDrawer}
                    title="Preview"
                >
                    <div style={{ width: '100%', height: '100vh' }}>
                        <PdfViewer
                            apiUrl={TCAppConfig.TC_PREVIEW}
                            params={{ tcId: tcId }}
                        />
                    </div>
                </ViewerModalPopup>
            )}
        </>
    );
};

// Material Ledger Transaction Cell Component
interface MaterialLedgerTransactionCellProps {
    cell: any;
    onAtcPreview?: (atcId: string) => void;
}

export const MaterialLedgerTransactionCell: React.FC<MaterialLedgerTransactionCellProps> = ({ cell, onAtcPreview }) => {
    const transactionType = cell.row.original.transactionType;
    const tcEtcMdfNumber = cell.getValue() as string;
    const atcId = cell.row.original.atcId;

    const handleTransactionClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        
        if (transactionType === 'ATC' && atcId && onAtcPreview) {
            onAtcPreview(atcId);
        } else if (transactionType === 'TC') {
            console.log('TC Transaction clicked:', tcEtcMdfNumber);
        }
    };

    // Only make clickable for TC and ATC transaction types
    if (transactionType === 'TC' || transactionType === 'ATC') {
        return (
            <Typography
                component="span"
                sx={{
                    color: '#0066cc',
                    textDecoration: 'none',
                    cursor: 'pointer',
                    fontWeight: 500,
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                }}
                onClick={handleTransactionClick}
            >
                {tcEtcMdfNumber}
            </Typography>
        );
    }
    
    // For other transaction types, display as normal text
    return <span>{tcEtcMdfNumber}</span>;
};

export const tableColumns = {
    dTrackit: [
        {
            accessorKey: "Action",
            header: "",
            minSize: 40,
            maxSize: 85,
            Cell: EditTC,

        },
        {
            accessorKey: "tcNo",
            header: "TC No.",
            minSize: 70,
            maxSize: 100
        },
        {
            accessorKey: "tcVersionNumber",
            header: "TC Version No.",
            minSize: 120,
            maxSize: 150,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 100,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 60,
            maxSize: 100,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer Country/Area",
            minSize: 100,
            maxSize: 180,
        },
        {
            accessorKey: "tcStandard",
            header: "TC Standard",
            minSize: 100,
            maxSize: 180,
        Cell: ({ cell }: { cell: any }) => {
            const standards = cell.getValue();
            if (Array.isArray(standards)) {
                return <span>{standards.join(", ")}</span>;
            }
            return <span>{standards}</span>;
        }
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "TC Certified Weight (kg)",
            minSize: 200,
            maxSize: 250,
            Cell: certifiedWeightCell
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issue Date",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "tcMetadataStatus",
            header: "Submission Status",
            minSize: 120,
            maxSize: 170,
            Cell: StatusCell
        },
        {
            accessorKey: "tcCreationDate",
            header: "Submitted Date",
            minSize: 100,
            maxSize: 150,
            Cell: ({ cell }: { cell: any }) => {
                const date = cell.getValue(); // Access the raw date value
                const formattedDate = moment(date).isValid()
                    ? moment(date).format("YYYY-MM-DD") // Format valid date
                    : date; // Fallback to raw value if invalid
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: "tcMetadataRejectionReason",
            header: "Reject Reason",
            minSize: 80,
            maxSize: 140,
            Cell: ({ row }: any) => <RejectReasonCell row={row} />,
        },
        {
            accessorKey: "tcParentMetadataStatus",
            header: "Parent Reject Reason",
            minSize: 80,
            maxSize: 140,
            enableHiding: true,
            show: false,
        },
        {
          accessorKey: "tcId",
          header: "TC-ID",
          minSize: 80,
          maxSize: 140,
          enableHiding: true,
          show: false,
        }
    ] as MRT_ColumnDef<{ status: string }>[],

    historical: [
        {
            accessorKey: "tcId",
            header: "TC No.",
            minSize: 60,
            maxSize: 150
        },
        {
            accessorKey: "tcVersionNumber",
            header: "TC Version No.",
            minSize: 60,
            maxSize: 100,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer Country/Area",
            minSize: 80,
            maxSize: 140,
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "TC Certified Weight (kg)",
            minSize: 100,
            maxSize: 150,
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issue Date",
            minSize: 80,
            maxSize: 120,

        }
    ] as MRT_ColumnDef<{ status: string }>[],

    eTrackit: [
        {
            accessorKey: "etcNo",
            header: "eTC No.",
            minSize: 60,
            maxSize: 100,
            Cell: NavETCNo
        },
        {
            accessorKey: "etcVersionNumber",
            header: "eTC Version No.",
            minSize: 100,
            maxSize: 160,
        },
        {
            accessorKey: "etcStatus",
            header: "eTC Status",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "sellerName",
            header: "Seller",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerName",
            header: "Buyer",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "buyerCountry",
            header: "Buyer's Country/Area",
            minSize: 200,
            maxSize: 250,
        },
        {
            accessorKey: "tcNetShippingWeight",
            header: "eTC Certified Weight (kg)",
            minSize: 300,
            maxSize: 350,
        },
        {
            accessorKey: "tcCreationDate",
            header: "Creation Date",
            minSize: 80,
            maxSize: 150,
        },
        {
            accessorKey: "tcDateOfIssue",
            header: "Issued Date",
            minSize: 80,
            maxSize: 120,
        },
        {
            accessorKey: "pendingDays",
            header: "Pending Days",
            minSize: 100,
            maxSize: 140,
        },
        {
            accessorKey: "tcMetadataStatus",
            header: "Current Status",
            minSize: 80,
            maxSize: 150,
            Cell: StatusCell
        },
        {
            accessorKey: "tcMetadataRejectionReason",
            header: "Reject Reason",
            minSize: 80,
            maxSize: 150,
        }
    ] as MRT_ColumnDef<{ status: string }>[],
    suppliers: [
        {
            accessorKey: 'tcNo', // From payload
            header: 'TC/e TC ID', // Column header text
            minSize: 150,
            maxSize: 250,
            Cell: NavSupNo
        },
        {
            accessorKey: 'buyerName', // Combined Buyer/Seller
            header: 'Buyer',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'sellerName', // Combined Buyer/Seller
            header: 'Seller',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'tcCreationDate', // From payload
            header: 'Creation Date',
            minSize: 150,
            maxSize: 250,
            Cell: ({ cell }: { cell: any }) => {
                const date = cell.getValue(); // Access the raw date value
                const formattedDate = moment(date).isValid()
                    ? moment(date).format("YYYY-MM-DD") // Format valid date
                    : date; // Fallback to raw value if invalid
                return <span>{formattedDate}</span>;
            },
        },
        {
            accessorKey: 'tcDateOfIssue', // From payload
            header: 'Issue Date',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'volumeSold', // Placeholder as it's not in the payload
            header: 'Volume Sold',
            minSize: 150,
            maxSize: 200,
        },
        {
            accessorKey: 'volumeBought', // Placeholder as it's not in the payload
            header: 'Volume Bought',
            minSize: 150,
            maxSize: 200,
        },
        {
            accessorKey: 'tcStatus', // From payload
            header: 'Status',
            minSize: 150,
            maxSize: 200,
            Cell: ({ cell }: any) => {
                const statusMapping: Record<string, string> = {
                    V: "Valid",
                    E: "Expired",
                    S: "Suspended",
                    W: "Withdrawn",
                };

                // Extract the status value from the row data
                const statusValue = cell.getValue();

                // Map the status value to the corresponding label
                const label = statusMapping[statusValue] || statusValue;

                return <span>{label}</span>;
            }
        },
    ] as MRT_ColumnDef<{ status: string }>[],
    materialLedger: [
        {
            accessorKey: 'transactionType',
            header: 'Transaction Type',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'inventoryType',
            header: 'Inventory Type',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'justificationReason',
            header: 'Volume Justification Reason',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'tcStatus',
            header: 'Status',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'transactionDate',
            header: 'Transaction Date',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'ledgerTransactionTimestamp',
            header: 'Submission Date',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'tcEtcMdfNumber',
            header: 'Transaction No.',
            minSize: 150,
            maxSize: 250,
            Cell: ({ cell }: { cell: any }) => {
                const transactionType = cell.row.original.transactionType;
                const tcEtcMdfNumber = cell.getValue() as string;
                
                // Only make clickable for TC and ATC transaction types
                if (transactionType === 'TC' || transactionType === 'ATC') {
                    return (
                        <Typography
                            component="span"
                            sx={{
                                color: '#0066cc',
                                textDecoration: 'none',
                                cursor: 'pointer',
                                fontWeight: 500,
                                '&:hover': {
                                    textDecoration: 'underline',
                                    color: '#003366',
                                }
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                        >
                            {tcEtcMdfNumber}
                        </Typography>
                    );
                }
                
                // For other transaction types, display as normal text
                return <span>{tcEtcMdfNumber}</span>;
            }
        },
        {
            accessorKey: 'tcVersionNumber',
            header: 'Version No.',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'sellerBuyerName',
            header: 'Seller/Buyer Name',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'productNumber',
            header: 'Product No.',
            minSize: 150,
            maxSize: 250,
        },
        // {
        //     accessorKey: 'productCategory',
        //     header: 'Input Product Category',
        //     minSize: 150,
        //     maxSize: 250,
        // },
        {
            accessorKey: 'productCategoryDesc',
            header: 'Input Product Category Description',
            minSize: 150,
            maxSize: 250,
        },
        // {
        //     accessorKey: 'productDetail',
        //     header: 'Input Product Detail',
        //     minSize: 150,
        //     maxSize: 250,
        // },
        {
            accessorKey: 'productDetailDesc',
            header: 'Input Product Detail Description',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'rmComposition',
            header: 'Input RM Composition',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedRmCodeDesc',
            header: 'Input Certified RM Code Description',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedWeightBought',
            header: 'Input Certified RM Weight (kg)',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'certifiedWeightSold',
            header: 'Input Certified Weight Used (kg)',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'outputProductCategoryDesc',
            header: 'Output Product Category Description',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'outputProductDetailDesc',
            header: 'Output Product Detail Description',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'outputCertifiedWeightSold',
            header: 'Output Certified RM Weight (Kg)',
            minSize: 150,
            maxSize: 250,
        },
        {
            accessorKey: 'balance',
            header: 'Balance',
            minSize: 150,
            maxSize: 250,
        },
    ] as MRT_ColumnDef<{ status: string }>[],
};

export const getColumnsBySource = (source: string) => {
    switch (source) {
        case 'dTrackit':
            return tableColumns.dTrackit;
        case 'historical':
            return tableColumns.historical;
        case 'eTrackit':
            return tableColumns.eTrackit;
        case 'suppliers':
            return tableColumns.suppliers;
        case 'materialLedger':
            return tableColumns.materialLedger;
        default:
            return tableColumns.dTrackit;  // default fallback
    }
}